import axios from "axios"
import config from "../config"

const baseURL = config.api.url

// GET TICKET DETAILS
export const getTicket = (id, rrn) =>
  new Promise((resolve, reject) => {
    const prefix = "/api/v1"
    const url = `${baseURL + prefix}/tickets/${id}/consume`
    const headers = {
      "request-reference-no": rrn,
    }
    axios
      .post(url, {}, { headers })
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })

export const storeTicket = (ticket) => {
  if (ticket.id) {
    sessionStorage.setItem(ticket.id, JSON.stringify(ticket))
  }
}

export const retrieveTicket = (id) =>
  JSON.parse(sessionStorage.getItem(id) || "{}")
